storefrontApp.service("digitalEventFormatterService", ["monthService", function (monthService) {
    function formatTime12Hour(hours24, minutes) {
        var period = hours24 >= 12 ? "PM" : "AM";
        var hours12 = hours24 % 12;
        if (hours12 === 0) {
            hours12 = 12;
        }
        var hourStr = hours12 < 10 ? "0" + hours12 : String(hours12);
        var minuteStr = (minutes < 10 ? "0" : "") + (minutes || 0);
        return hourStr + ":" + minuteStr + " " + period;
    }

    function parseIsoDateTime(isoString) {
        var dateParts = isoString.split("T");
        var datePart = dateParts[0];
        var timePart = dateParts[1].replace("Z", "");
        var dotIndex = timePart.indexOf(".");
        if (dotIndex > -1) {
            timePart = timePart.substring(0, dotIndex);
        }

        var dateArray = datePart.split("-");
        var timeArray = timePart.split(":");

        return {
            year: parseInt(dateArray[0], 10),
            month: parseInt(dateArray[1], 10),
            day: parseInt(dateArray[2], 10),
            hours: parseInt(timeArray[0], 10),
            minutes: parseInt(timeArray[1], 10)
        };
    }

    return {
        formatTime12Hour: formatTime12Hour,
        enrichEvent: function (event) {
            var dateStr = event.goLive || event.eventStartDate;
            if (!dateStr) {
                return event;
            }

            try {
                var parsed = parseIsoDateTime(dateStr);
                var monthName = monthService.monthNames[parsed.month - 1];
                var formattedEventDate = monthName + " " + parsed.day + ", " + parsed.year;
                var formattedStartTime = formatTime12Hour(parsed.hours, parsed.minutes);

                var result = {};
                for (var key in event) {
                    if (event.hasOwnProperty(key)) {
                        result[key] = event[key];
                    }
                }

                result.eventDate = formattedEventDate;
                result.eventDateTime = formattedEventDate + " @ " + formattedStartTime;
                result.eventStartTime = formattedStartTime;

                if (event.eventDuration) {
                    var totalMinutes = parsed.hours * 60 + parsed.minutes + event.eventDuration;
                    var endHours = Math.floor(totalMinutes / 60) % 24;
                    var endMinutes = totalMinutes % 60;
                    result.eventEndTime = formatTime12Hour(endHours, endMinutes);
                }

                return result;
            } catch (error) {
                console.error("Error processing event:", error);
                return event;
            }
        }
    };
}]);
